import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Optional } from '@angular/core';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { ISizeName } from '@df/core/service/client';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { NICmsContentComponent } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';
import { UsInfoModalInitiatorService } from './us-info-modal-initiator.service';

export const US_INFO_MODAL_NAME = 'us-info';
/**
 * TODO: (iCMS) check component
 */
@Component({
    selector: 'us-info-modal',
    templateUrl: './us-info-modal.html',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})

@DfModal({
    id: US_INFO_MODAL_NAME,
    position: 'custom',
    name: US_INFO_MODAL_NAME,
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        height: 'auto',
        minWidth: undefined,
        maxWidth: undefined,
        width: sizeId === 'S' ? '100%' : '31.5em',
        modalClass: 'bg-col-w p-r-4 p-l-4 p-t-7 p-b-7',
        transitionOptions: '500ms ease-in-out'
    }),
    blockGroup: 'modals',
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeName => ['S', 'M', 'L', 'X'],
    priority: 40,
    initiators: [UsInfoModalInitiatorService]
})
export class UsInfoModalComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent, OnInit {

    constructor(
        @Optional() private modalRef: ModalRef<UsInfoModalComponent>,
        private localStorageService: LocalStorageService
    ) {
        super();
    }

    /**
     * Closes the modal
     */
    protected close() {
        this.localStorageService.set(US_INFO_MODAL_NAME, 1);
        this.modalRef?.close();
    }
}
